function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#313d53"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.63 3.333c-.781.033-1.728.52-2.289 1.176-.504.582-.944 1.51-.825 2.401.873.069 1.762-.442 2.305-1.098.542-.657.909-1.569.81-2.48zm-.22 15.502c1.058-.02 1.729-.96 2.377-1.907a8.536 8.536 0 001.071-2.191l.006-.017-.004-.002c-.102-.041-2.062-.837-2.082-3.137-.019-1.9 1.498-2.845 1.665-2.949l.013-.008c-.913-1.333-2.335-1.516-2.842-1.537-.74-.074-1.458.208-2.044.439-.373.147-.693.272-.931.272-.266 0-.595-.13-.963-.276-.483-.19-1.034-.41-1.603-.399-1.318.02-2.535.766-3.214 1.946-1.37 2.375-.351 5.895.984 7.821.654.942 1.431 2.002 2.454 1.964.456-.018.781-.156 1.117-.299.388-.165.791-.337 1.43-.337.607 0 .992.167 1.362.326.353.153.694.3 1.203.29z",
  fill: "#fff"
})));